import { rootPrefix } from '#/routing/routes';

export const authLoginAuthRequiredSearchParam = 'auth_required';

export const authLoginPath = rootPrefix.path('login', [
  'invite',
  'to',
  authLoginAuthRequiredSearchParam,
]);

export const authSignupPath = rootPrefix.path('signup', ['invite', 'to']);

export const authForgotPasswordPath = rootPrefix.path('forgot-password');

export const authUserInvitePath = rootPrefix.path('user-invites/:inviteId');

export const authResetPasswordPath = rootPrefix.path('reset-password/:token');

export const authMfaPath = rootPrefix.path('mfa/:token');
